export default __webpack_public_path__ + "static/media/Polaris.5dcc8c47.otf";